var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.6172 5)",
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25586 16.8604C6.25586 16.1282 6.71616 15.475 7.40572 15.2287V15.2287C10.5146 14.1184 13.912 14.1184 17.0209 15.2287V15.2287C17.7105 15.475 18.1708 16.1282 18.1708 16.8604V17.98C18.1708 18.9905 17.2757 19.7668 16.2753 19.6239L15.9417 19.5763C13.4687 19.223 10.958 19.223 8.48491 19.5763L8.15136 19.6239C7.15093 19.7668 6.25586 18.9905 6.25586 17.98V16.8604Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3194 11.9022C18.7966 11.9022 19.9941 10.7047 19.9941 9.22744C19.9941 7.75021 18.7966 6.55267 17.3194 6.55267",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.251 18.0036L20.5131 18.041C21.2991 18.1533 22.0024 17.5434 22.0024 16.7493V15.8697C22.0024 15.2944 21.6407 14.7812 21.0989 14.5877C20.5585 14.3946 20.0069 14.2443 19.4492 14.1367",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68747 11.9022C5.21023 11.9022 4.0127 10.7047 4.0127 9.22744C4.0127 7.75021 5.21023 6.55267 6.68747 6.55267",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75777 18.0036L3.4957 18.041C2.70965 18.1533 2.00638 17.5434 2.00638 16.7493V15.8697C2.00638 15.2944 2.36804 14.7812 2.90984 14.5877C3.45029 14.3946 4.00184 14.2443 4.55957 14.1367",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/Component.4763028b67381d6483f33114510cc10f.svg";
export { ForwardRef as ReactComponent };